import { render, staticRenderFns } from "./PackageListEdit.vue?vue&type=template&id=538faacf&"
import script from "./PackageListEdit.vue?vue&type=script&lang=js&"
export * from "./PackageListEdit.vue?vue&type=script&lang=js&"
import style0 from "./PackageListEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports